import { QUIZ_CARD_HEADER_CLASSNAME } from '@/shared/components/QuizCard';

/**
 * @description ai 문제 생성 애니메이션
 * @param aiSaveQuizId 추가된 문제 리스트들의 id
 */
export const aiSaveAnimation = (aiSaveQuizId: string[]) => {
  setTimeout(() => {
    const targetQuizCards = aiSaveQuizId.map(id => document.getElementById(id));

    const scrollTarget = targetQuizCards[0];
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    targetQuizCards.forEach(card => {
      const header = card?.querySelector(`.${QUIZ_CARD_HEADER_CLASSNAME}`);
      if (header) {
        header.classList.add('animate-shine-background');
        header.setAttribute('style', '--shine-background-color: #E7E4FF');
      }

      setTimeout(() => {
        if (header) {
          header.classList.remove('animate-shine-background');
          header.removeAttribute('style');
        }
      }, 1000);
    });
  }, 100);
};
